<template>
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.1421 3.1499C15.0146 3.01657 14.8552 2.99992 14.6957 2.99992H11.3479V0.999919C11.3479 0.633252 11.0291 0.333252 10.6783 0.333252H5.32181C4.97109 0.333252 4.65226 0.633252 4.65226 0.999919V2.99992H1.30443C0.953705 2.99992 0.666748 3.21659 0.666748 3.58325V12.9999C0.666748 13.3666 0.953705 13.6666 1.30443 13.6666H14.6957C15.0465 13.6666 15.3334 13.3666 15.3334 12.9999V3.61658C15.3334 3.43324 15.2697 3.28324 15.1421 3.1499ZM5.92762 1.66659H10.0725V2.99992H5.92762V1.66659ZM14.0581 4.33325V7.83325H9.59428V7.58325C9.59428 7.29992 9.3392 7.16658 9.06819 7.16658H6.91602C6.645 7.16658 6.38994 7.31658 6.38994 7.58325V7.83325H1.92617V4.33325H14.0581ZM8.63776 8.16658V8.49992H7.3624V8.16658H8.63776ZM1.94211 12.3333V8.83325H6.40588V8.99992C6.40588 9.28325 6.66096 9.49992 6.93197 9.49992H9.08415C9.35516 9.49992 9.61022 9.26658 9.61022 8.99992V8.83325H14.074V12.3333H1.94211Z" fill="#29ABE2"/>
  </svg>

</template>

<script>
  export default {
    name: 'thingsIcon'
  }
</script>
